export const COOKIE_DOMAIN = '.globalcredit.ua';
